"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var get_session_properties_response_1 = require("./get-session-properties-response");
/**
 * Serialiser for {@link GetSessionProperties}
 */
var GetSessionPropertiesResponseSerialiserClass = /** @class */ (function (_super) {
    __extends(GetSessionPropertiesResponseSerialiserClass, _super);
    function GetSessionPropertiesResponseSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GetSessionProperties} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GetSessionProperties} that was read
     */
    GetSessionPropertiesResponseSerialiserClass.prototype.read = function (bis) {
        if (Codec.readBoolean(bis)) {
            return new get_session_properties_response_1.GetSessionPropertiesResponse(Codec.readDictionary(bis, Codec.readString));
        }
        else {
            return null;
        }
    };
    return GetSessionPropertiesResponseSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GetSessionPropertiesResponseSerialiserClass = GetSessionPropertiesResponseSerialiserClass;
/**
 * The {@link GetSessionPropertiesResponseSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GetSessionPropertiesResponseSerialiser = new GetSessionPropertiesResponseSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/get-session-properties-response-serialiser.js
// module id = 1248
// module chunks = 1